import { Campaign } from "../domains/index.js";
import { collectService } from "../services"
import { DateUtils } from "../utils/index.js";

export default class CampaignPredicate {
  constructor({ popupContext }) {
    this.popupContext = popupContext
    this.readyExposureList = []
    this.exposedTemplateTypes = new Set()
  }

  test({ campaignList, abTestList, client, originReferrer }) {
    this.readyExposureList = [ ...campaignList, ...abTestList ]
    this.exposedTemplateTypes = new Set()
    const isNoneExposure = (item) => (item?.msgTemplateObject?.exposure || 'EXPOSURE') === 'NONE_EXPOSURE'
    const isSkippable = (item) => {
      const campaign = new Campaign({ ...item })
      return campaign.isTodayClose()
    }
    const readyExposureByType = new Map()
    this.readyExposureList.forEach(item => {
      const templateType = item?.msgTemplateObject?.templateType
      if (!templateType) {
        return
      }
      const typeList = readyExposureByType.get(templateType) || []
      typeList.push(item)
      readyExposureByType.set(templateType, typeList)
    })
    readyExposureByType.forEach(campaigns => {
      campaigns.sort((a, b) => DateUtils.getCreatedAtMillSeconds(b?.createdAt) - DateUtils.getCreatedAtMillSeconds(a?.createdAt))
    })
    readyExposureByType.forEach(campaigns => {
      campaigns.filter(item => !isNoneExposure(item))
          .forEach(item => this.testCampaignItem(item, client, originReferrer))
    })
    readyExposureByType.forEach((campaigns, templateType) => {
      if (this.exposedTemplateTypes.has(templateType)) {
        return
      }
      const newestNoneExposure = campaigns.find(item => isNoneExposure(item) && !isSkippable(item))
      if (!newestNoneExposure) {
        return
      }
      this.testCampaignItem(newestNoneExposure, client, originReferrer)
    })
  }

  testCampaignItem(campaignItem, client, originReferrer) {
    const campaign = new Campaign({ ...campaignItem })
    const url = new URL(location.href)
    if (campaign.isTodayClose() || campaign.id === url.searchParams.get('utmCampaignId')) {
      return
    }
    campaign.handleConversion(async () => {
      await collectService.collectInflow(client, campaignItem.id, campaignItem.$reference, campaignItem.msgTemplateObject.sortOrder)
      location.href = campaign.getConnectionUrlWithParams()
    })
    const handler = () => {
      const exposure = campaign.msgTemplateObject?.exposure || 'EXPOSURE'
      const templateType = campaign.msgTemplateObject?.templateType
      if (!templateType) return
      //  중복 시 미노출(NONE_EXPOSURE): 실제로 이미 노출된 templateType이면 미노출
      if (exposure === 'NONE_EXPOSURE' && this.exposedTemplateTypes.has(templateType)) {
        return
      }
      const popup = campaign.getPopup()
      this.popupContext.addPopupThenShow(popup)
      this.exposedTemplateTypes.add(templateType)
      collectService.collectExposure(client, campaignItem.id, campaignItem.$reference, campaignItem.msgTemplateObject.sortOrder)
    }
    if (!campaign.triggerYn) {
      handler()
      return
    }
    campaign.getTriggerRuleAsEventList({ referrer: originReferrer }).forEach(({ triggerMode, isDetectedEvent, targetElements, selector, action, timeOnPage }) => {
      const detectedEventHandler = (handleEvent) => {
        const registered = new WeakSet()
        const addListener = (element) => {
          if (registered.has(element)) {
            return
          }
          registered.add(element)
          element.addEventListener(action, e => handleEvent(e))
        }
        targetElements?.forEach(addListener)
        const observer = new MutationObserver((mutations, mutationObserver) => {
          mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
            if (!(node instanceof Element)) {
              return
            }
            if (node.matches && node.matches(selector)) {
              addListener(node)
            }
            node.querySelectorAll && node.querySelectorAll(selector).forEach(addListener)
          }))
        })
        observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
        })
      }
      switch (triggerMode) {
        case 'Immediate':
          if (isDetectedEvent) {
            detectedEventHandler(e => handler(e))
          } else {
            handler()
          }
          break
        case 'TimeOnPage':
          if (isDetectedEvent) {
            detectedEventHandler(e => {
              setTimeout(handler, timeOnPage * 1000)
            })
          } else {
            setTimeout(handler, timeOnPage * 1000)
          }
          break
      }
    })
  }
}
